import { render, staticRenderFns } from "./GiftCardComponent.vue?vue&type=template&id=18018a7b&scoped=true"
import script from "./GiftCardComponent.vue?vue&type=script&lang=js"
export * from "./GiftCardComponent.vue?vue&type=script&lang=js"
import style0 from "./GiftCardComponent.vue?vue&type=style&index=0&id=18018a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18018a7b",
  null
  
)

export default component.exports